import { createSelector } from '@ngrx/store';
import * as mainStateSearchBenchmark from '../reducers';
import * as fromsubStateSearchBenchmark from '../reducers/search-benchmarks.reducer';

export const selectSearchBenchMarkRequest = createSelector(
  mainStateSearchBenchmark.selectSearchBenchmarkState,
  fromsubStateSearchBenchmark.selectSearchBenchmarks
);

export const selectSearchBenchMarkLoaded = createSelector(
  mainStateSearchBenchmark.selectSearchBenchmarkState,
  fromsubStateSearchBenchmark.selectSearchBenchmarksLoaded
);

export const selectSearchBenchMarkFailure = createSelector(
  mainStateSearchBenchmark.selectSearchBenchmarkState,
  fromsubStateSearchBenchmark.selectSearchBenchmarksError
);
